import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Teach tailwind-merge about the custom font-size tokens defined as
// `--text-*` CSS variables in `src/styles/tailwind.css`. Without this,
// utilities like `text-h1` or `text-body` get misclassified as text-color
// and conflict with `text-fx-*`, causing one or the other to be dropped
// during merge.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'large',
            'medium',
            'body',
            'text',
            'small',
            'caption',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
